import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../login.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { Observable } from 'rxjs/Observable';
import { INgxMyDpOptions, IMyDateModel } from 'ngx-mydatepicker';
import { AutosuggestService } from '../autosuggest.service';

@Component({
  selector: 'app-add-whats-app-template',
  templateUrl: './add-whats-app-template.component.html',
  styleUrls: ['./add-whats-app-template.component.css']
})
export class AddWhatsAppTemplateComponent implements OnInit {
  headerLabel: string;
  onlyview: boolean;
  showLoader: boolean;
  model: any = {};
  currentUser: any;

  constructor(
    private router: Router,
    private loginservice: LoginService,
    private Autosuggest: AutosuggestService,
    private _arout: ActivatedRoute,
    private _flashMessagesService: FlashMessagesService

  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(this.loginservice.getLocalSession('currentUser'));
    this._arout.params.subscribe(p => {
      if (p.view_id) {
        this.onlyview = true;
      }
      if (p.id) {
        this.headerLabel = 'Edit';
        this.loginservice.getTemplatedetail(p.id, this.currentUser).subscribe(data => {
          this.model = data;
          this.dup();
        },
          error => {
            alert('Network Error getTemplatedetail API');
            this.showLoader = false;
          });
      } else {
        // alert("Please Fill Exact Details Which You have Given in What's App Intergration Panel")
        this.model.mediaType = "photo";
        this.model.StaticDynamic = 'Static';
        this.model.BStaticDynamic = 'Static';
        this.model.contentHasVariable = '0';
        this.model.noOfVariable = '1';
        this.model.variable1 = "";
        this.model.variable2 = "";
        this.model.variable3 = "";
        this.model.variable4 = "";
        this.model.variable5 = "";
        this.model.variable6 = "";
        this.model.hasMedia = '1';
        this.model.hasButton = '0';
      }
    }, error => { alert('Network Error params API'); });
  }

  addRemove() {
    if (this.model.noOfVariable === '1') {
      this.model.variable2 = "";
      this.model.variable3 = "";
      this.model.variable4 = "";
      this.model.variable5 = "";
      this.model.variable6 = "";
    } else if (this.model.noOfVariable === '2') {
      this.model.variable3 = "";
      this.model.variable4 = "";
      this.model.variable5 = "";
      this.model.variable6 = "";
    } else if (this.model.noOfVariable === '3') {
      this.model.variable4 = "";
      this.model.variable5 = "";
      this.model.variable6 = "";
    } else if (this.model.noOfVariable === '4') {
      this.model.variable5 = "";
      this.model.variable6 = "";
    } else if (this.model.noOfVariable === '5') {
      this.model.variable6 = "";
    } else if (this.model.noOfVariable === '6') {

    }
  }

  dup() {
    if (this.model.MessageTemplate === '' || !this.model.MessageTemplate) {
      this.model.MessageTemplate = this.model.MessageTemplate1 = '';
      this.model.noOfVariable = 0; this.model.contentHasVariable = '0';
    }
    const template = this.model.MessageTemplate

    // Regular expression to match placeholders in the format {{number}}
    const placeholders = template.match(/\{\{\d+\}\}/g);

    // Count the placeholders
    this.model.noOfVariable = placeholders ? placeholders.length : 0;

    if (this.model.noOfVariable > 0) {
      this.model.contentHasVariable = '1';
    }

    this.model.MessageTemplate1 = this.model.MessageTemplate;
    if (this.model.variable1) {
      this.model.MessageTemplate1 = this.model.MessageTemplate1.replace(/\{\{1\}\}/g, this.model.variable1);
    }
    if (this.model.variable2) {
      this.model.MessageTemplate1 = this.model.MessageTemplate1.replace(/\{\{2\}\}/g, this.model.variable2);
    }
    if (this.model.variable3) {
      this.model.MessageTemplate1 = this.model.MessageTemplate1.replace(/\{\{3\}\}/g, this.model.variable3);
    }
    if (this.model.variable4) {
      this.model.MessageTemplate1 = this.model.MessageTemplate1.replace(/\{\{4\}\}/g, this.model.variable4);
    }
    if (this.model.variable5) {
      this.model.MessageTemplate1 = this.model.MessageTemplate1.replace(/\{\{5\}\}/g, this.model.variable5);
    }
    if (this.model.variable6) {
      this.model.MessageTemplate1 = this.model.MessageTemplate1.replace(/\{\{6\}\}/g, this.model.variable6);
    }
  }

  saveWhatsAppTemplate() {
    this.showLoader = true;
    this.loginservice.saveTemplatedetail(this.model, this.currentUser).subscribe(data => {
      if (data['status'] === 'success') {
        this._flashMessagesService.show('Updated Successfully', { cssClass: 'alert-success' });
      } else {
        this._flashMessagesService.show(data['message'], { cssClass: 'alert-danger' });
      }
      this.router.navigate(['/WhatsAppMsgTemplate']);
      this.showLoader = false;
      // this.model = data;
    },
      error => {
        alert('Network Error saveTemplatedetail API');
        this.showLoader = false;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/add-whats-app-template/add-whats-app-template.component.ts